export const MESSAGE_TOASTS = {
  MESSAGE_RECEIVED: 'New message from #{name}',
};
